/* eslint-disable radix */
import React from 'react'
import { useFetchContent } from 'src/hooks/useContentful/useFetchContent'
import { getSection } from 'src/hooks/useContentful/getSection'
import { useOffer } from '../../hooks/offer'
import CustomLink from '../CustomLink'
import Loading from '../Loading'

import {
	WrapperContainer,
	HeaderContainer,
	PartnerImg,
  ImagemVeloe
} from './styles'

export default function Header() {
  const { currentOffer } = useOffer();
  const { data, isLoading } = useFetchContent();

  if (isLoading || !data) return <Loading />;

  const { isGeneric } = data.fields;
  const section = getSection({ sectionName: 'landingNav', data });
  const parceiroLogo = section.parceiroLogo.fields.file.url;
  const veloeLogo = section.veloeLogo.fields.file.url;

  return (
    <WrapperContainer>
        <HeaderContainer>
          <CustomLink
            to="/unidasseminovos"
            tagLabel="logo-veloe"
            parentComponent="menu"
          >
          <ImagemVeloe src={`https://${veloeLogo}`} alt={veloeLogo} />
          </CustomLink>
          {currentOffer && currentOffer.logo ? (
              <PartnerImg src={currentOffer.logo} alt="Parceiro" />
          ) : !isGeneric && parceiroLogo ? (
              <PartnerImg src={parceiroLogo} alt="Parceiro" />
          ) : null}
        </HeaderContainer>
    </WrapperContainer>
  );
}

// Header.propTypes = {};

// export default Header;
